<template>
    <RenderlessPagination
        :data="data"
        :limit="limit"
        :keep-length="keepLength"
        @pagination-change-page="onPaginationChangePage"
        v-slot="slotProps"
    >
        <ul
            v-bind="$attrs"
            class="pagination"
            :class="{
                'pagination-sm': size == 'small',
                'pagination-lg': size == 'large',
                'justify-content-center': align == 'center',
                'justify-content-end': align == 'right'
            }"
            style="align-items: baseline;"
            v-if="slotProps.computed.total > slotProps.computed.perPage">

            <li class="page-item pagination-prev-nav" :class="{'disabled': !slotProps.computed.prevPageUrl}" v-if="slotProps.computed.prevPageUrl || showDisabled">
                <a class="page-link" href="#" aria-label="Previous" :tabindex="!slotProps.computed.prevPageUrl && -1" v-on="slotProps.prevButtonEvents">
                    <slot name="prev-nav">
                        <span aria-hidden="true">&laquo;</span>
                        <span class="sr-only">Previous</span>
                    </slot>
                </a>
            </li>

            <li class="page-item pagination-page-nav" v-for="(page, key) in slotProps.computed.pageRange" :key="key" :class="{ 'active': page == slotProps.computed.currentPage }">
                <input :class="error ? 'error' : ''" style="width: 40px; height: 25px; font-size: 0.875rem; text-align: center;"
                       v-if="page == slotProps.computed.currentPage"
                       v-model="newPage"
                       v-on:keyup.enter="changePage"
                       :disabled="loading"
                       :min="1"
                       :max="data.meta.last_page"
                       @keypress="isNumber($event)"
                       @change="clearError"
                       @focusout="changePage"
                />
                <a v-else class="page-link" href="#" v-on="slotProps.pageButtonEvents(page)">
                    {{ page }}
                    <span class="sr-only" v-if="page == slotProps.computed.currentPage">(current)</span>
                </a>
            </li>

            <li class="page-item pagination-next-nav" :class="{'disabled': !slotProps.computed.nextPageUrl}" v-if="slotProps.computed.nextPageUrl || showDisabled">
                <a class="page-link" href="#" aria-label="Next" :tabindex="!slotProps.computed.nextPageUrl && -1" v-on="slotProps.nextButtonEvents">
                    <slot name="next-nav">
                        <span aria-hidden="true">&raquo;</span>
                        <span class="sr-only">Next</span>
                    </slot>
                </a>
            </li>

        </ul>
    </RenderlessPagination>
</template>

<script>
import RenderlessPagination from 'laravel-vue-pagination/src/RenderlessPagination.vue';

export default {
    compatConfig: {
        MODE: 3
    },

    inheritAttrs: false,

    emits: ['pagination-change-page'],

    components: {
        RenderlessPagination
    },

    props: {
        data: {
            type: Object,
            default: () => {}
        },
        limit: {
            type: Number,
            default: 0
        },
        keepLength: {
            type: Boolean,
            default: false
        },
        showDisabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'default',
            validator: value => {
                return ['small', 'default', 'large'].indexOf(value) !== -1;
            }
        },
        align: {
            type: String,
            default: 'left',
            validator: value => {
                return ['left', 'center', 'right'].indexOf(value) !== -1;
            }
        },
        loading: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            newPage: this.data.meta.current_page,
            error: false
        }
    },
    watch: {
        data(newValue) {
            this.newPage = newValue.meta.current_page
        }
    },
    methods: {
        onPaginationChangePage (page) {
            this.$emit('pagination-change-page', page);
            this.newPage = page;
        },
        changePage() {
            if (this.newPage >= 1 && this.newPage <= this.data.meta.last_page) {
                this.$emit('pagination-change-page', this.newPage);
            } else {
                this.error = true;
            }
        },
        isNumber($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if (keyCode < 48 || keyCode > 57) {
                $event.preventDefault();
            }
        },
        clearError() {
            this.error = false;
        }
    }
}
</script>

<style>
.error {
    border: 1px solid red;
}
</style>
